import { encryptData } from '@/components/default/utils/crypto';
import { ACCESS_TOKEN_DURATION, CHECK_SUBSCRIPTION_STATUS, DASHBOARD_REPORT, PUBLIC_API_URL, TENANT_CHECK_LOGGED_IN_USER, TENANT_HOME_LOGGED_IN_USER } from '../../../constants/api';
import CookieService from '../../app/cookie.service';
import StorageService from '../../app/storage.service';
import { ApiInterceptionFetch } from '../api.interceptor';

class DashboardService {
    static checkLoggedInUser = async (token, domainType, domain) => {
        try {
            const response = await ApiInterceptionFetch(
                `${PUBLIC_API_URL}${TENANT_CHECK_LOGGED_IN_USER}`,
                {
                    method: 'POST',
                    body: JSON.stringify({
                        token: token,
                        type: domainType,
                    }),
                    headers: {
                        'X-Tenant-ID': domain,
                    },
                },
                false,
            );

            if (!response.ok) {
                const errorData = await response.json();
                // Handle error response here if needed
                // For example, you can log the error or show a notification
                console.error('Error in service:', errorData);
                throw errorData;
            }

            const data = await response.json();

            CookieService.set('token', data.data.access_token, ACCESS_TOKEN_DURATION);
            StorageService.set('user', encryptData(data.data.user));
            StorageService.set('role', encryptData(data.data.user.role));
            StorageService.set('permissions', encryptData(data.data.user.permissions));

            return data; // Return data for further use if needed
        } catch (error) {
            throw error; // Throw error for handling in components
        }
    };

    static report = async (params = {}) => {
        try {
            const response = await ApiInterceptionFetch(`${PUBLIC_API_URL}${DASHBOARD_REPORT}`, {
                method: 'POST',
                body: JSON.stringify(params),
            });

            if (!response.ok) {
                const errorData = await response.json();
                // Handle error response here if needed
                // For example, you can log the error or show a notification
                console.error('Error in service:', errorData);
                throw errorData;
            }

            const data = await response.json();
            return data; // Return data for further use if needed
        } catch (error) {
            throw error; // Throw error for handling in components
        }
    };

    static checkLoggedInTenant = async () => {
        try {
            const response = await ApiInterceptionFetch(`${PUBLIC_API_URL}${TENANT_HOME_LOGGED_IN_USER}`, {
                method: 'POST',
            });

            if (!response.ok) {
                const errorData = await response.json();
                // Handle error response here if needed
                // For example, you can log the error or show a notification
                console.error('Error in service:', errorData);
                throw errorData;
            }
            const data = await response.json();
            return data; // Return data for further use if needed
        } catch (error) {
            throw error; // Throw error for handling in components
        }
    };

    static checkSubscription = async () => {
        try {
            const response = await ApiInterceptionFetch(
                `${PUBLIC_API_URL}${CHECK_SUBSCRIPTION_STATUS}`,
                {
                    method: 'POST'
                }
            );

            if (!response.ok) {
                const errorData = await response.json();
                // Handle error response here if needed
                // For example, you can log the error or show a notification
                console.error('Error in service:', errorData);
                throw errorData;
            }
            const data = await response.json();
            return data; // Return data for further use if needed
        } catch (error) {
            throw error; // Throw error for handling in components
        }
    };
}
export default DashboardService;
